import { make } from 'vuex-pathify';
import client from '@/api';
import state from './state';

export default {
    ...make.actions(state),

    loadVenues: ({ dispatch, getters }) => {
        client.execute('get', `events/${getters.eventId}/venues`)
            .then(data => dispatch('setVenues', data));
    },

    async saveVenue({ dispatch, getters }) {
        const venue = {
            event_id: getters.eventId,
            venue_id: getters.venue.account.id,
            notes: getters.venue.notes,
            status: getters.venue.status,
            amount: getters.venue.amount,
        };

        if (!getters.venue.id) {
            await client.execute('post', `events/${getters.eventId}/venues`, venue);
        } else {
            await client.execute('patch', `events/${getters.eventId}/venues/${getters.venue.id}`, venue);
        }

        dispatch('loadVenues');
        dispatch('resetModal');
    },

    resetModal: ({ dispatch }) => {
        dispatch('setVenue', {});
        dispatch('setShowAddModal', false);
    },

    async updateVenue({ dispatch, getters }, venue) {
        await client.execute('patch', `events/${getters.eventId}/venues/${venue.id}`, venue);
        dispatch('loadVenues');
    },

    deleteVenue: ({ dispatch, getters }) => {
        client.execute('delete', `events/${getters.eventId}/venues/${getters.deleteVenueId}`)
            .then(() => dispatch('loadVenues'));

        dispatch('setDeleteVenueId', null);
    },
};
